interface UpdateModalProps {
  isOpen: boolean
  onClose: () => void
}

const UpdateModal = ({ isOpen, onClose }: UpdateModalProps) => {
  if (!isOpen) return null

  return (
    <div className="modal-overlay" onClick={onClose} style={{ zIndex: 10001 }}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{ 
          maxWidth: '500px', 
          textAlign: 'center'
        }}
      >
        <div className="modal-header" style={{ borderBottom: 'none', display: 'block', textAlign: 'center' }}>
          <h2 style={{ margin: 0 }}>Aktualizacja konfiguratora</h2>
        </div>
        <div className="modal-body">
          <p>Konfigurator został zaktualizowany do najnowszej wersji.</p>
          <button 
            className="btn-primary" 
            onClick={onClose} 
            style={{ 
              borderRadius: 0,
              marginTop: '20px'
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  )
}

export default UpdateModal
